// extracted by mini-css-extract-plugin
export default {"tabs":"O8-z","tablist":"P8-z","tablistItem":"Q8-z"};